import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';

type Props = React.InputHTMLAttributes<HTMLInputElement>;

function CheckboxContainer(props: Props) {
    const newProps = {
        ...props,
        className: classNames(props.className, 'styled-checkboxes'),
    };
    return <div {...newProps} />;
}

CheckboxContainer.propTypes = {
    className: PropTypes.string,
};

export default CheckboxContainer;
